/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Group_RemoveInputs */

const en_editor_group_remove = /** @type {(inputs: Editor_Group_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove group`)
};

const de_editor_group_remove = /** @type {(inputs: Editor_Group_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe entfernen`)
};

/**
* | output |
* | --- |
* | "Remove group" |
*
* @param {Editor_Group_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_group_remove = /** @type {((inputs?: Editor_Group_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Group_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_group_remove(inputs)
	return en_editor_group_remove(inputs)
});